'use strict';

var React = require('react');

var SvgReplayMinor = function SvgReplayMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.635 7.666c0 .272.106.528.298.72a1.044 1.044 0 0 0 1.441 0l2.326-2.327a1.013 1.013 0 0 0 0-1.442l-2.326-2.327a1.042 1.042 0 0 0-1.44 0 1.008 1.008 0 0 0-.299.72c0 .272.106.528.3.72l.588.59h-5.687c-3.77-.002-6.836 3.068-6.836 6.838 0 3.775 3.066 6.842 6.836 6.842 3.346 0 6.252-2.495 6.757-5.8.002-.009.016-.115.016-.194l.002-.352a1.02 1.02 0 0 0-1.018-1.019 1.02 1.02 0 0 0-1.019 1.019v.19c0 .318-.117.658-.139.728-.628 1.97-2.51 3.39-4.599 3.39a4.806 4.806 0 0 1-4.8-4.802 4.807 4.807 0 0 1 4.8-4.803h5.687l-.589.589a1.012 1.012 0 0 0-.299.72z"
  }));
};

exports.SvgReplayMinor = SvgReplayMinor;
